<template>
  <b-card no-body>

    <div class="card-body p-1">
      <div class="row">
        <div class="col-md-12 d-flex align-items-center">

          <div class="col-12 col-md-4">
            <b-form-group
              label="Tìm kiếm khoảng ngày tạo"
              label-for="borr"
            >
              <div class="input-group">
                <flat-pickr
                  v-model="localSearchQuery.end_date"
                  :value="localSearchQuery.end_date"
                  class="form-control"
                  :config="configDateRange"
                  placeholder="dd/mm/yyyy - dd/mm/yyyy"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-default"
                    style="border-color: #d8d6de;"
                    type="button"
                    title="Xóa"
                    data-clear
                  >
                    <feather-icon icon="XIcon" />
                  </button>
                </div>
              </div>
            </b-form-group>
          </div>
          <div class="col-12 col-md-4">
            <div
              id="__BVID__427"
              role="group"
              class="form-group"
            >
              <label
                id="__BVID__427__BV_label_"
                for="borr"
                class="d-block mt-2"
              /><div>
                <b-button
                  variant="primary"
                  @click="updateSearchQuery"
                  @keyup.enter="updateSearchQuery"
                >
                  <feather-icon icon="SearchIcon" /> Tìm kiếm
                </b-button></div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BFormGroup,
} from 'bootstrap-vue';
import { ref } from '@vue/composition-api';
// import useCategoryTypeDevice from './useCategoryTypeDevice';
import flatPickr from 'vue-flatpickr-component';

import vSelect from 'vue-select'
import { Vietnamese } from 'flatpickr/dist/l10n/vn';

import store from '@/store'
import axiosNews from '@/libs/axiosNews';
// import { props } from 'vue-prism-component';
import useFacebook from './useFacebook';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    flatPickr,
    BFormGroup,
    vSelect,
  },
  props: {
    searchQuery: ref({}),
    itemsData: ref({}),

    statusFilter: {
      type: [Number, null],
      default: null,
    },
  },
  methods: {

  },
  setup(props, { emit }) {
    const { statusOptions } = useFacebook();
    const checked = ref(false)
    const dataStream = ref([])

    const localSearchQuery = ref({
      end_date: '',
      keyword: '',
      status: '',

    });
    const updateSearchQuery = () => {
      emit('search', localSearchQuery.value);
    };
    Vietnamese.rangeSeparator = ' - ';

    const configDateRange = ref({
      dateFormat: 'd/m/Y',
      mode: 'range',
      wrap: true,
      showMonths: 2,
      locale: Vietnamese, // locale for this instance only
    });
    return {
      localSearchQuery,
      updateSearchQuery,
      statusOptions,
      checked,
      configDateRange,

    };
  },
};
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
